import _ from 'lodash'
import moment from 'moment'
import {
  ConcreteLevel,
  ConcreteResistanceLevel,
  ConcreteThreashold,
  ConcreteThreasholdById,
  ConcreteVoltageLevel,
  Device,
  Log,
  State,
  Category,
} from '../../types'
import { getLoginUserDeviceIds } from '../Auth/selectors'
import { getTimestamp } from '../Clock/selectors'
import { getUser } from '../UserById/selectors'

export const getDevice = (state: State, deviceId: string) =>
  state.DeviceById[deviceId]
export const getDeviceIds = (state: State, category?: Category) => {
  if (!category) {
    return _.keys(state.DeviceById)
  }
  return _.values(state.DeviceById)
    .filter((d) => d.category === category)
    .map((v) => v.id)
}

// ConcreteMonitor

export const getVisibleConcreteMonitorDeviceIds = (
  state: State,
  visible = true,
) => {
  const devices = getConcreteMonitorDevices(state)
  const list = _.sortBy(
    visible ? devices.filter((v) => v.info.visible) : devices,
    [(v) => v.info.priority, (v) => v.info.label],
  )

  return list.map((v) => v.id)
}

export const getConcreteMonitorDevices = (state: State) => {
  const deviceIds = getLoginUserDeviceIds(state)

  return _.filter(
    deviceIds.map((did) => getConcreteMonitorDevice(state, did)),
    (v) => !!v,
  ) as Device[]
}

export const getCurrentUser = (state: State, deviceId: string) => {
  const device = getDevice(state, deviceId)

  return getUser(state, device.currentUserId)
}

export const getConcreteMonitorDevice = (state: State, deviceId: string) => {
  const device = getDevice(state, deviceId)

  if (!device) {
    return undefined
  }
  const now = getTimestamp(state)

  return convertConcreteMonitorDevice(device, now)
}

const levelExpand = (
  level: ConcreteLevel,
): {
  resistanceLevel: ConcreteResistanceLevel
  voltageLevel: ConcreteVoltageLevel
} => ({
  resistanceLevel: ['X', 'D', 'C', 'B', 'A', 'A', 'A'][
    level
  ] as ConcreteResistanceLevel,
  voltageLevel: ['X', 'D', 'A', 'A', 'A', 'B', 'C'][
    level
  ] as ConcreteVoltageLevel,
})

export const convertConcreteMonitorLog = (log: Log): Log => {
  const sensors = _.map(_.range(1, 12), (id) => {
    const sensor = log.fields.sensors[id]
    const level: ConcreteLevel = (sensor && sensor.level) || 0

    return {
      ...sensor,
      level,
      ...levelExpand(level),
    }
  })

  return {
    ...log,
    fields: {
      sensors,
    },
  }
}

export const convertConcreteDeviceInfo = (
  info: unknown,
): ConcreteThreasholdById => {
  const keys = _.range(1, 12)
  const dummy: ConcreteThreasholdById = _.mapValues(
    _.zipObject(keys, keys),
    (): ConcreteThreashold => ({
      resistance: { levelA: 0, levelB: 0, levelC: 0 },
      voltage: { levelA: 0 },
      time: {
        levelA: 0,
        levelB: 0,
      },
    }),
  )

  return _.merge(dummy, info)
}

const convertConcreteMonitorDevice = (device: Device, now: number): Device => {
  const info = device.info || {}
  const threasholds = convertConcreteDeviceInfo(info)

  return {
    ...device,
    lastLog: device.lastLog
      ? convertConcreteMonitorLog(device.lastLog)
      : undefined,
    info: {
      priority: info.priority || 0,
      label: info.label || '',
      visible: info.visible || false,
      threasholds,
      memo: info.memo || '',
      token: info.token || '',
      ...convertKeep(device.updatedAt, now),
      status: info.status || undefined,
    },
  }
}

function convertKeep(
  timestamp: undefined | number,
  now: number,
): { keepedStr: string; keeped: boolean } {
  if (!timestamp) {
    return { keepedStr: 'データなし', keeped: false }
  }
  const ts = moment(timestamp)
  const keeped = ts.isAfter(moment(now).subtract(1, 'minute'))

  return {
    keepedStr: `${keeped ? '接続あり' : '接続なし'}`,
    // keepedStr: `${keeped ? '記録中' : '記録停止中'} (${ts.fromNow()})`,
    keeped,
  }
}
